
import { useEffect } from 'react';
import { supabase } from "@/integrations/supabase/client";

export const useRlsSetup = () => {
  useEffect(() => {
    const setupRlsPolicies = async () => {
      try {
        console.log('Setting up RLS policies for saved_campaigns table');
        await supabase.functions.invoke('setup-rls-policies');
        console.log('RLS policies setup complete');
      } catch (error) {
        console.error('Error setting up RLS policies:', error);
      }
    };
    
    setupRlsPolicies();
  }, []);
};
